import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import { FeatureFlags } from "featureFlags";
import { EmbeddedVideoDetailsPage } from "features/Assets/components/EmbeddedVideo/EmbeddedVideoDetailsPage";
import { useFeatureFlag } from "features/common/hooks/useFeatureFlag";
import { AssessmentDetailsPage, AssetDetailsPage, SurveyDetailsPage } from "../../../Assets/components";
import { PdfDetailsPage } from "../../../Assets/components/PdfDetailsPage/PdfDetailsPage";
import { EventRoutes } from "../../../Events/components/EventRoutes/EventRoutes";
import { FlowPage } from "../../../Flows/components/FlowPage/FlowPage";
import { FlowRedirect } from "../../../Flows/components/FlowPage/FlowRedirect";
import { clearFilters } from "../../redux/searchResults/searchResultsSlice";
import { DiscoverPage } from "../DiscoverPage/DiscoverPage";

export const DiscoverPageRoutes: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const embeddedVideoEnabled = useFeatureFlag(FeatureFlags.EmbeddedVideos);

  // When navigating back to the discover page
  // ie by clicking "Discover" while the page
  // is already open, remove any previously active
  // filters.
  useEffect(() => {
    if (!location.search) {
      dispatch(clearFilters());
    }
  }, [location.search, dispatch]);

  return (
    <Routes>
      <Route
        path={"flows/:flowId"}
        element={
          <FlowRedirect>
            <FlowPage />
          </FlowRedirect>
        }
      />
      <Route path={"asset/:assetId"} element={<AssetDetailsPage />} />
      <Route path={"assessment/:assessmentId"} element={<AssessmentDetailsPage />} />
      <Route path={"survey/:surveyId"} element={<SurveyDetailsPage />} />
      <Route path={"event/*"} element={<EventRoutes />} />
      <Route path={"pdf/:pdfId"} element={<PdfDetailsPage />} />
      {embeddedVideoEnabled && (
        <Route path={"embedded-video/:embeddedVideoId"} element={<EmbeddedVideoDetailsPage />} />
      )}
      <Route index element={<DiscoverPage />} />
      <Route path={"*"} element={<Navigate to="/discover" replace />} />
    </Routes>
  );
};
